<template>
  <div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :sort-options="{
        enabled: true,
      }"
      styleClass="vgt-table bordered"
      :pagination-options="{
        enabled: true,
        mode: 'registros',
        position: 'top',
        perPage: 15,
        nextLabel: 'siguiente',
        prevLabel: 'anterior',
        rowsPerPageLabel: 'Filas por página',
        ofLabel: 'de',
        pageLabel: 'páginas', // for 'pages' mode
        allLabel: 'Todos',
      }"
    />
  </div>
</template>
<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      columns: [
        {
          label: 'Nombre de Empresa',
          field: 'EnterpriseName',
          filterOptions: {
            placeholder: 'Nombre de Empresa',
            enabled: true
          }
        },
        {
          label: 'Rfc',
          field: 'Rfc',
          filterOptions: {
            placeholder: 'Rfc',
            enabled: true
          }
        },
        {
          label: 'Dirección',
          field: 'Address',
          filterOptions: {
            placeholder: 'Dirección',
            enabled: true
          }
        },
        {
          label: 'Estado',
          field: 'State',
          filterOptions: {
            placeholder: 'Estado',
            enabled: true
          }
        },
        {
          label: 'Ciudad',
          field: 'City',
          filterOptions: {
            placeholder: 'Ciudad',
            enabled: true
          }
        },
        {
          label: 'Web',
          field: 'WebSite',
          filterOptions: {
            placeholder: 'Web',
            enabled: true
          }
        },
        {
          label: 'Contacto',
          field: 'ContactName',
          filterOptions: {
            placeholder: 'Contacto',
            enabled: true
          }
        },
        {
          label: 'Contacto Tél.',
          field: 'ContactPhoneNumber',
          filterOptions: {
            placeholder: 'Contacto Tél.',
            enabled: true
          }
        },
        {
          label: 'Contacto Mail',
          field: 'ContactEmail',
          filterOptions: {
            placeholder: 'Contacto Mail',
            enabled: true
          }
        }
      ],
      rows: []
    }
  },
  async mounted () {
    try {
      const response = await axiosAdelaService.post('/getReportEnterprise', JSON.stringify({}))
      if (response.status === 200) {
        this.rows = response.data
      }
    } catch (error) {
      this.showError('No se pudieron obtener el reporte intentalo mas tarde.')
    }
  }
}
</script>
